import { Badge, Text, Tooltip } from '@mantine/core';

// KnowledgeBase's StatusBadge knows published/archived and not live/disabled; connectors keep their
// own map rather than change a module nine screens import.
export const STATUS_COLORS = { draft: 'warning', validated: 'info', live: 'success', disabled: 'gray' };

export const STATUS_TOOLTIPS = {
  draft: 'Draft — never called for shoppers; probe, then mark validated.',
  validated: 'Validated — probe passed; not yet serving.',
  live: 'Live — answers shopper questions on this store right now.',
  disabled: 'Disabled — kept, not serving.',
};

export const ConnectorStatusBadge = ({ status, size = 'sm' }) => (
  <Tooltip label={STATUS_TOOLTIPS[status] || status} multiline maw={260} withArrow>
    <Badge variant="light" color={STATUS_COLORS[status] || 'gray'} size={size}>
      {status}
    </Badge>
  </Tooltip>
);

export const apiBaseFor = (accountId, domainId) => `/api/admin/accounts/${accountId}/domains/${domainId}/connectors`;

// The small caps title of the probe and response cards, so they read as one family of blocks.
export const PanelCardTitle = ({ children }) => (
  <Text fz={11} fw={600} c="dimmed" tt="uppercase" style={{ letterSpacing: '0.04em' }} mb={6}>
    {children}
  </Text>
);
